import {CacheKey, Deserializer, JsonProperty, ObjectMapper, Serializer} from "json-object-mapper";
import {Channel} from "./channels.model";

export class PipelineState {

  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "data"})
  public data?: string = undefined;

  @JsonProperty({name: "process"})
  public process?: string = undefined;

  @JsonProperty({name: "channel"})
  public channel: Channel = new Channel();

  @JsonProperty({name: "status"})
  public status?: string = undefined;

}

@CacheKey("ArrayPipelineStateSerializerDeserializer")
export class ArrayPipelineStateSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): PipelineState[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(PipelineState, v);
    })
  }
  serialize = (values: PipelineState[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class RealtimeState {

  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "data"})
  public data?: string = undefined;

  @JsonProperty({name: "process"})
  public process?: string = undefined;

  @JsonProperty({name: "channel"})
  public channel: Channel = new Channel();

  @JsonProperty({name: "status"})
  public status?: string = undefined;

}

@CacheKey("ArrayRealtimeStateSerializerDeserializer")
export class ArrayRealtimeStateSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): RealtimeState[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(RealtimeState, v);
    })
  }
  serialize = (values: RealtimeState[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class Machine {

  @JsonProperty({name: "owner"})
  public owner?: string = undefined;

  @JsonProperty({name: "batch"})
  public batch?: string = undefined;

  @JsonProperty({name: "alarm"})
  public alarm?: string = undefined;

  @JsonProperty({name: "cron"})
  public cron?: string = undefined;

  @JsonProperty({type: PipelineState, deserializer: ArrayPipelineStateSerializerDeserializer, name: "pipelines"})
  public pipelines: PipelineState[] = [];

  @JsonProperty({type: RealtimeState, deserializer: ArrayRealtimeStateSerializerDeserializer, name: "realtime"})
  public realtime: RealtimeState[] = [];

  @JsonProperty({name: "updated"})
  public updated?: string = undefined;

  @JsonProperty({name: "status"})
  public status?: string = undefined;
}
